import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CompanyService } from '@s-services/company.service';

@Component({
    selector: 'app-list-booking-groups',
    templateUrl: './list-booking-groups.component.html',
    styleUrls: ['./list-booking-groups.component.scss'],
    imports: [
        CommonModule,
    ]
})
export class ListBookingGroupsComponent implements OnInit {
  @Output() handleBgClick = new EventEmitter();

  constructor(
    public companyService: CompanyService,
  ) { }

  ngOnInit() {

  }

}
